
import { Component, Vue, Prop } from 'vue-property-decorator';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';
import depositService from '@/services/deposit-services';
import { APP_CONFIG } from '@/config/app-config';
@Component({
    components: {
        ConfirmModal
    }
})
export default class ListTransition extends Vue {
    @Prop({default: {}})
    private listItem: any;
    private selectedItem: any;
    private isConfirm = false;
    private modalContent = 'Bạn có thực sự muốn nhận mã vận đơn?';
    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private createDeposit(item: any) {
        this.selectedItem = item;
        this.isConfirm = true;
    }

    private async onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        // Tạo mới đơn ký gửi là mã vận đơn vừa nhận
        if (eventData.data === 'OK') {
            const dataRequest = {
                UID: this.userInfo.userId,
                Username: this.userInfo.userName,
                Status: 16,
                CurentCNYVN: this.rate,
                Transactions: [
                    { 
                        ID: this.selectedItem.ID,
                        OrderTransactionCode: this.selectedItem.OrderTransactionCode,
                        ActionType: 'auto_from_noname'
                    }
                ]
            };

            const result = await depositService.createDeposit(dataRequest);
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Tạo mới ký gửi thành công!',
                });
                this.$router.push({ name: 'deposit-detail', params: { id: result.data.data.ID.toString() } }).catch(() => {
                    return false;
                });
            } else if (result && result.data.status === 202) {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: result.data.error,
                });
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Có lỗi trong quá trình xử lý dữ liệu!',
                });
            }
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }
}
